<template>
  <div class="dots-loader">
    <div class="dots-wrapper" :style="{ color }">&bull;&bull;&bull;</div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "grey",
    },
  },
};
</script>

<style lang="scss" scoped>
$loader-width: 50px;
$dot-radius: 4px;
$dots-width: 100%;
$animation-duration: 1s;

@keyframes dots {
  from {
    transform: translate(-100%);
  }
  to {
    transform: translate(48px);
  }
}

.dots-loader {
  width: $loader-width;
  overflow: hidden;

  .dots-wrapper {
    width: $dots-width;
    display: flex;
    justify-content: center;
    letter-spacing: 1.5px;
    overflow: hidden;
    position: relative;
    font-size: 10px;
    animation: dots $animation-duration linear infinite;
  }
}
</style>
